import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container, Typography, Box, Paper, TextField, Button,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Divider, Card, CardContent, Grid, CircularProgress,
    Snackbar, Alert, Tooltip, Dialog, DialogTitle, DialogContent,
    DialogActions, TablePagination, InputAdornment, Tabs, Tab,
    FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel,
    LinearProgress, Chip
} from '@mui/material';
import {
    Delete as DeleteIcon,
    CloudUpload as CloudUploadIcon,
    Visibility as VisibilityIcon,
    Edit as EditIcon,
    Save as SaveIcon,
    Close as CloseIcon,
    Search as SearchIcon,
    Add as AddIcon,
    ArrowBack as ArrowBackIcon,
    Medication as MedicationIcon,
    ReceiptLong as ReceiptIcon,
    ExpandMore as ExpandMoreIcon,
    TableChart as TableChartIcon,
    AutoAwesome as BrasindiceIcon,
    KeyboardArrowUp as ArrowUpIcon,
    KeyboardArrowDown as ArrowDownIcon,
    Upload as UploadIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import flaskServer from '../config/flaskserver';
import AnimatedText from '../layout/AnimatedText';
import StyledButton from '../layout/StyledButton';

const CadastrosFaturamento = () => {
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(0);
    const [convenios, setConvenios] = useState([]);
    const [novoNome, setNovoNome] = useState('');
    const [loading, setLoading] = useState(false);
    const [importing, setImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [dashboardLag, setDashboardLag] = useState(null);
    const [customConvenios, setCustomConvenios] = useState([]); // Para a aba Tabelas Personalizadas
    const [subTabIpe, setSubTabIpe] = useState(0); // 0: Insumos, 1: Despesas

    // State for Brasindice
    const [brasindice, setBrasindice] = useState([]);
    const [searchBrasindice, setSearchBrasindice] = useState('');
    const [loadingBrasindice, setLoadingBrasindice] = useState(false);
    const [brasindicePage, setBrasindicePage] = useState(0);
    const [brasindiceRowsPerPage, setBrasindiceRowsPerPage] = useState(10);

    // Multi-source pricing (FontePrecoConvenio)
    const [expandedConvenio, setExpandedConvenio] = useState(null);  // convenio id currently expanded
    const [fontesPorConvenio, setFontesPorConvenio] = useState({});  // { convenio_id: [fontes] }
    const [novaFonteDialogOpen, setNovaFonteDialogOpen] = useState(false);
    const [novaFonteConvenioId, setNovaFonteConvenioId] = useState(null);
    const [brasindiceVersoesParaRegra, setBrasindiceVersoesParaRegra] = useState([]);
    const [novaFonte, setNovaFonte] = useState({
        nome: '', categoria: 'PROCEDIMENTO', fonte: 'IMPORTADA',
        prioridade: 1, base_referencia: 'PF', percentual_ajuste: 0, versao_brasindice: '',
        vigencia_inicio: '', vigencia_fim: '', filtro_carteira: ''
    });

    const [editFonteDialogOpen, setEditFonteDialogOpen] = useState(false);
    const [editingFonte, setEditingFonte] = useState(null);

    // Confirmação de exclusão de convênio
    const [deleteConfirmation, setDeleteConfirmation] = useState({ open: false, id: null, isCustom: false, data: null });

    // Itens da Fonte Visualization
    const [itensFonteDialogOpen, setItensFonteDialogOpen] = useState(false);
    const [itensDaFonte, setItensDaFonte] = useState([]);
    const [itensTotal, setItensTotal] = useState(0);
    const [itensPage, setItensPage] = useState(1);
    const [itensRowsPerPage, setItensRowsPerPage] = useState(10);
    const [searchItens, setSearchItens] = useState('');
    const [loadingItens, setLoadingItens] = useState(false);
    const [selectedFonte, setSelectedFonte] = useState(null);

    // Editing Itens
    const [editingItemId, setEditingItemId] = useState(null);
    const [editValues, setEditValues] = useState({ codigo: '', descricao: '', valor: '' });

    // Brasindice import (aba Base Brasíndice)
    const [importInfo, setImportInfo] = useState({ versao: '', vigencia: '' });
    const [importTypeSelector, setImportTypeSelector] = useState('MEDICAMENTO');
    const [versionDialogOpen, setVersionDialogOpen] = useState(false);
    const [brasindiceVersoes, setBrasindiceVersoes] = useState([]);
    const [currentImportType, setCurrentImportType] = useState(null); // 'TISS' or 'BRASINDICE'
    const [targetConvenioId, setTargetConvenioId] = useState(null);
    const [versoesTabela, setVersoesTabela] = useState([]);
    const [selectedConvenioVersions, setSelectedConvenioVersions] = useState(null);

    // IPE Custom Reference Tables (Tab 2)
    const [ipeDespesas, setIpeDespesas] = useState([]);
    const [ipeInsumos, setIpeInsumos] = useState([]);
    const [loadingIpe, setLoadingIpe] = useState(false);
    const [ipePage, setIpePage] = useState(0);
    const [ipeRowsPerPage, setIpeRowsPerPage] = useState(10);
    const [searchIpe, setSearchIpe] = useState('');
    const [ipeTotal, setIpeTotal] = useState(0);

    // Edição de Nome do Convênio
    const [editConvenioDialogOpen, setEditConvenioDialogOpen] = useState(false);
    const [editingConvenio, setEditingConvenio] = useState({ id: null, nome: '' });

    // Advanced Filtering and Sorting State
    const [filters, setFilters] = useState({
        tipo: '', laboratorio: '', nome_comercial: '', apresentacao: '', ean: '', tiss: '', tuss: ''
    });
    const [sortConfig, setSortConfig] = useState({ key: 'nome_comercial', direction: 'asc' });

    const filteredBrasindice = React.useMemo(() => {
        let result = [...brasindice];

        // Filtering
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                const val = filters[key].toLowerCase();
                result = result.filter(item => {
                    const itemVal = String(item[key] || '').toLowerCase();
                    return itemVal.includes(val);
                });
            }
        });

        // Sorting
        result.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
            if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });

        return result;
    }, [brasindice, filters, sortConfig]);

    const handleRequestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setBrasindicePage(0);
    };

    useEffect(() => {
        if (tabValue === 0) {
            fetchConvenios(false);
            fetchDashboardLag();
        }
        if (tabValue === 1) fetchBrasindice();
        if (tabValue === 2) {
            fetchConvenios(true);
            fetchIpeData();
        }
    }, [tabValue]);

    const fetchDashboardLag = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/convenios/dashboard/brasindice-lag`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setDashboardLag(response.data);
        } catch (error) {
            console.error('Erro ao carregar defasagem', error);
        }
    };

    const fetchConvenios = async (isCustom = false) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/convenios?is_custom=${isCustom}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (isCustom) {
                setCustomConvenios(response.data.convenios || []);
            } else {
                setConvenios(response.data.convenios || []);
            }
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao carregar convênios', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const fetchIpeData = async () => {
        setLoadingIpe(true);
        try {
            const token = localStorage.getItem('token');
            const endpoint = subTabIpe === 0 ? 'insumos' : 'despesas';
            const response = await axios.get(`${flaskServer.flaskServerIP}/ipe/${endpoint}?page=${ipePage + 1}&per_page=${ipeRowsPerPage}&search=${searchIpe}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (subTabIpe === 0) setIpeInsumos(response.data.itens || []);
            else setIpeDespesas(response.data.itens || []);
            setIpeTotal(response.data.total || 0);
        } catch (error) {
            console.error('Erro ao buscar dados IPE:', error);
        } finally {
            setLoadingIpe(false);
        }
    };

    useEffect(() => {
        if (tabValue === 2) fetchIpeData();
    }, [subTabIpe, ipePage, ipeRowsPerPage]);

    const fetchBrasindice = async () => {
        setLoadingBrasindice(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/brasindice`, {
                headers: { 'Authorization': `Bearer ${token}` },
                params: { search: searchBrasindice }
            });
            setBrasindice(response.data.itens || []);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao carregar Brasíndice', severity: 'error' });
        } finally {
            setLoadingBrasindice(false);
        }
    };

    const fetchFontes = async (convenioId) => {
        const token = localStorage.getItem('token');
        try {
            const [fontesRes, versoesRes] = await Promise.all([
                axios.get(`${flaskServer.flaskServerIP}/convenios/${convenioId}/fontes`, { headers: { 'Authorization': `Bearer ${token}` } }),
                axios.get(`${flaskServer.flaskServerIP}/convenios/brasindice-versoes`, { headers: { 'Authorization': `Bearer ${token}` } })
            ]);
            setFontesPorConvenio(prev => ({ ...prev, [convenioId]: fontesRes.data.fontes || [] }));
            setBrasindiceVersoesParaRegra(versoesRes.data.versoes || []);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao carregar fontes de preço', severity: 'error' });
        }
    };

    const handleToggleConvenio = (convenioId) => {
        if (expandedConvenio === convenioId) {
            setExpandedConvenio(null);
        } else {
            setExpandedConvenio(convenioId);
            if (!fontesPorConvenio[convenioId]) fetchFontes(convenioId);
        }
    };

    const openNovaFonteDialog = (convenioId) => {
        setNovaFonteConvenioId(convenioId);
        setNovaFonte({ nome: '', categoria: 'PROCEDIMENTO', fonte: 'IMPORTADA', prioridade: 1, base_referencia: 'PF', percentual_ajuste: 0, versao_brasindice: '', vigencia_inicio: '', vigencia_fim: '' });
        setNovaFonteDialogOpen(true);
        if (!brasindiceVersoesParaRegra.length) {
            const token = localStorage.getItem('token');
            axios.get(`${flaskServer.flaskServerIP}/convenios/brasindice-versoes`, { headers: { 'Authorization': `Bearer ${token}` } })
                .then(r => setBrasindiceVersoesParaRegra(r.data.versoes || []));
        }
    };

    const handleCreateFonte = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${flaskServer.flaskServerIP}/convenios/${novaFonteConvenioId}/fontes`, novaFonte, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setSnackbar({ open: true, message: 'Fonte de preço criada!', severity: 'success' });
            setNovaFonteDialogOpen(false);
            fetchFontes(novaFonteConvenioId);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao criar fonte', severity: 'error' });
        }
    };

    const handleOpenEditFonte = (f) => {
        setEditingFonte({
            ...f,
            percentual_ajuste: f.percentual_ajuste || 0,
            vigencia_inicio: f.vigencia_inicio || '',
            vigencia_fim: f.vigencia_fim || '',
            filtro_carteira: f.filtro_carteira || ''
        });
        setEditFonteDialogOpen(true);
    };

    const handleUpdateFonte = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${flaskServer.flaskServerIP}/convenios/fontes/${editingFonte.id}`, editingFonte, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setSnackbar({ open: true, message: 'Fonte atualizada!', severity: 'success' });
            setEditFonteDialogOpen(false);
            fetchFontes(expandedConvenio);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao atualizar fonte', severity: 'error' });
        }
    };

    const handleImportIpeDespesas = async (file, fonteId = null) => {
        if (!file) return;
        setImporting(true);
        setImportProgress(0);
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('file', file);
        if (fonteId) formData.append('fonte_id', fonteId);

        try {
            const response = await axios.post(`${flaskServer.flaskServerIP}/ipe/despesas/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setImportProgress(progress);
                }
            });
            setSnackbar({ open: true, message: response.data.message, severity: 'success' });
            if (tabValue === 2) fetchIpeData();
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro na importação IPE Despesas', severity: 'error' });
        } finally {
            setImporting(false);
            setImportProgress(0);
        }
    };

    const handleDeleteFonte = async (fonteId, convenioId) => {
        if (!window.confirm('Excluir esta fonte de preço e todos os seus itens?')) return;
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${flaskServer.flaskServerIP}/convenios/fontes/${fonteId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setSnackbar({ open: true, message: 'Fonte removida', severity: 'success' });
            fetchFontes(convenioId);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao remover fonte', severity: 'error' });
        }
    };

    const handleImportToFonte = async (fonteId, convenioId, file) => {
        if (!file) return;
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('file', file);
        try {
            const res = await axios.post(`${flaskServer.flaskServerIP}/convenios/fontes/${fonteId}/import`, formData, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });
            setSnackbar({ open: true, message: res.data.message, severity: 'success' });
            fetchFontes(convenioId);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro na importação', severity: 'error' });
        }
    };

    const handleUpdatePrioridade = async (fonteId, convenioId, novaPrioridade) => {
        const token = localStorage.getItem('token');
        try {
            await axios.put(`${flaskServer.flaskServerIP}/convenios/fontes/${fonteId}`, { prioridade: novaPrioridade }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchFontes(convenioId);
        } catch (e) { /* silent */ }
    };

    const fetchItensDaFonte = async (fonteId, page = 1, search = '') => {
        setLoadingItens(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/convenios/fontes/${fonteId}/itens`, {
                headers: { 'Authorization': `Bearer ${token}` },
                params: { page, per_page: itensRowsPerPage, search }
            });
            setItensDaFonte(response.data.itens || []);
            setItensTotal(response.data.total || 0);
            setItensPage(response.data.current_page || 1);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao carregar itens da fonte', severity: 'error' });
        } finally {
            setLoadingItens(false);
        }
    };

    const handleVerItens = (fonte) => {
        setSelectedFonte(fonte);
        setItensPage(1);
        setSearchItens('');
        setEditingItemId(null);
        setItensFonteDialogOpen(true);
        fetchItensDaFonte(fonte.id, 1, '');
    };

    const handleStartEdit = (item) => {
        setEditingItemId(item.id);
        setEditValues({
            codigo: item.codigo,
            descricao: item.descricao,
            valor: item.valor?.toString().replace('.', ',') || '0,00'
        });
    };

    const handleSaveEdit = async () => {
        try {
            const token = localStorage.getItem('token');
            const data = {
                codigo: editValues.codigo,
                descricao: editValues.descricao,
                valor: editValues.valor
            };
            await axios.put(`${flaskServer.flaskServerIP}/convenios/fontes/itens/${editingItemId}`, data, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setSnackbar({ open: true, message: 'Item atualizado!', severity: 'success' });
            setEditingItemId(null);
            fetchItensDaFonte(selectedFonte.id, itensPage, searchItens);
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao atualizar item', severity: 'error' });
        }
    };


    const handleImportBrasindice = async (file) => {
        if (!file) return;
        setImporting(true);
        setImportProgress(0);
        try {
            const token = localStorage.getItem('token');
            const data = new FormData();
            data.append('file', file);
            data.append('versao', importInfo.versao);
            data.append('vigencia', importInfo.vigencia);
            data.append('tipo', importTypeSelector);

            // Usar fetch para suporte a streaming
            const response = await fetch(`${flaskServer.flaskServerIP}/brasindice/upload`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: data
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Erro na importação');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value);
                const lines = chunk.split('\n\n');
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const jsonStr = line.replace('data: ', '').trim();
                            if (!jsonStr) continue;
                            const progressData = JSON.parse(jsonStr);
                            if (progressData.progress !== undefined) {
                                setImportProgress(progressData.progress);
                            }
                            if (progressData.message === 'Concluído') {
                                setSnackbar({
                                    open: true,
                                    message: `Importação concluída: ${progressData.validas} itens`,
                                    severity: 'success'
                                });
                            }
                        } catch (e) {
                            console.error("Erro ao processar chunk de progresso", e, line);
                        }
                    }
                }
            }
            fetchBrasindice();
        } catch (error) {
            setSnackbar({ open: true, message: error.message || 'Erro na importação Brasíndice', severity: 'error' });
        } finally {
            setImporting(false);
            setTimeout(() => setImportProgress(0), 1000);
        }
    };

    const handleImportIpeMeds = async (file) => {
        if (!file) return;
        setImporting(true);
        setImportProgress(0);
        try {
            const token = localStorage.getItem('token');
            const data = new FormData();
            data.append('file', file);
            data.append('versao', importInfo.versao || 'IPE_Saude');

            const response = await fetch(`${flaskServer.flaskServerIP}/ipe/medicamentos/upload`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: data
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Erro na importação IPE');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value);
                const lines = chunk.split('\n\n');
                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const jsonStr = line.replace('data: ', '').trim();
                            if (!jsonStr) continue;
                            const progressData = JSON.parse(jsonStr);
                            if (progressData.progress !== undefined) setImportProgress(progressData.progress);
                            if (progressData.message === 'Concluído') {
                                setSnackbar({ open: true, message: `Importação IPE concluída: ${progressData.validas} itens`, severity: 'success' });
                            }
                        } catch (e) { console.error(e); }
                    }
                }
            }
            fetchBrasindice();
        } catch (error) {
            setSnackbar({ open: true, message: error.message, severity: 'error' });
        } finally {
            setImporting(false);
            setTimeout(() => setImportProgress(0), 1000);
        }
    };

    const handleImportIpeInsumos = async (file) => {
        if (!file) return;
        setImporting(true);
        setImportProgress(0);
        try {
            const token = localStorage.getItem('token');
            const data = new FormData();
            data.append('file', file);

            const response = await axios.post(`${flaskServer.flaskServerIP}/ipe/insumos/upload`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setImportProgress(percentCompleted);
                }
            });

            setSnackbar({
                open: true,
                message: `Importação IPE concluída: ${response.data.total_processado} itens`,
                severity: 'success'
            });
            fetchBrasindice(); // Refresh if needed, or other view
        } catch (error) {
            setSnackbar({ open: true, message: error.response?.data?.message || 'Erro na importação', severity: 'error' });
        } finally {
            setImporting(false);
            setTimeout(() => setImportProgress(0), 1000);
        }
    };

    const handleImport = async (id, file) => {
        if (!file) return;
        setImporting(true);
        const formData = new FormData();
        formData.append('file', file);
        try {
            const token = localStorage.getItem('token');
            const data = new FormData();
            data.append('file', file);
            data.append('versao', importInfo.versao);
            data.append('vigencia', importInfo.vigencia);
            const response = await axios.post(`${flaskServer.flaskServerIP}/convenios/${id}/import-tabela`, data, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
            });
            setSnackbar({ open: true, message: response.data.message, severity: 'success' });
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro na importação', severity: 'error' });
        } finally {
            setImporting(false);
        }
    };

    const handleCreate = async (isCustom = false) => {
        if (!novoNome) return;
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${flaskServer.flaskServerIP}/convenios`, { nome: novoNome, is_custom: isCustom }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setNovoNome('');
            fetchConvenios(isCustom);
            setSnackbar({ open: true, message: 'Convênio criado com sucesso!', severity: 'success' });
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao criar convênio', severity: 'error' });
        }
    };

    const handleUpdateConvenio = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${flaskServer.flaskServerIP}/convenios/${editingConvenio.id}`, { nome: editingConvenio.nome }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setEditConvenioDialogOpen(false);
            fetchConvenios(false);
            setSnackbar({ open: true, message: 'Convênio renomeado!', severity: 'success' });
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao atualizar convênio', severity: 'error' });
        }
    };

    const handleDeleteConvenio = async (id, isCustom = false) => {
        if (!window.confirm('Iniciar processo de exclusão deste convênio? O sistema fará um levantamento dos vínculos primeiro.')) return;
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${flaskServer.flaskServerIP}/convenios/${id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchConvenios(isCustom);
            setSnackbar({ open: true, message: 'Convênio excluído com sucesso!', severity: 'success' });
        } catch (error) {
            if (error.response?.status === 409 && error.response?.data?.requires_confirmation) {
                // Dependency warning => open the detailed modal
                setDeleteConfirmation({
                    open: true,
                    id: id,
                    isCustom: isCustom,
                    data: error.response.data
                });
            } else {
                setSnackbar({ open: true, message: 'Erro ao excluir convênio', severity: 'error' });
            }
        }
    };

    const confirmDeleteConvenio = async () => {
        const { id, isCustom } = deleteConfirmation;
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${flaskServer.flaskServerIP}/convenios/${id}?force=true`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setDeleteConfirmation({ open: false, id: null, isCustom: false, data: null });
            fetchConvenios(isCustom);
            setSnackbar({ open: true, message: 'Convênio e todos os seus vínculos foram excluídos com sucesso!', severity: 'success' });
        } catch (error) {
            setDeleteConfirmation({ open: false, id: null, isCustom: false, data: null });
            setSnackbar({ open: true, message: 'Erro ao forçar exclusão do convênio', severity: 'error' });
        }
    };


    const fetchTissVersions = async (convenioId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/convenios/${convenioId}/tabela/versoes`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setVersoesTabela(response.data.versoes || []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchBrasindiceVersions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${flaskServer.flaskServerIP}/brasindice/versoes`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setBrasindiceVersoes(response.data.versoes || []);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteTissVersion = async (versao, vigencia) => {
        if (!window.confirm(`Excluir importação ${versao}/${vigencia}?`)) return;
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${flaskServer.flaskServerIP}/convenios/${selectedConvenioVersions.id}/tabela/excluir`,
                { versao, vigencia }, { headers: { 'Authorization': `Bearer ${token}` } }
            );
            fetchTissVersions(selectedConvenioVersions.id);
            setSnackbar({ open: true, message: 'Importação excluída', severity: 'success' });
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao excluir', severity: 'error' });
        }
    };

    const handleDeleteBrasindiceVersion = async (versao) => {
        if (!window.confirm(`Excluir importação ${versao}?`)) return;
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${flaskServer.flaskServerIP}/brasindice/importacao/excluir`,
                { versao }, { headers: { 'Authorization': `Bearer ${token}` } }
            );
            fetchBrasindiceVersions();
            fetchBrasindice();
            setSnackbar({ open: true, message: 'Importação excluída', severity: 'success' });
        } catch (error) {
            setSnackbar({ open: true, message: 'Erro ao excluir', severity: 'error' });
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={() => navigate('/auditoria-tiss')} sx={{ mr: 2 }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                        <AnimatedText text="Gestão de Faturamento" />
                    </Typography>
                </Box>
                <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)} sx={{
                    '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', fontSize: '1rem' }
                }}>
                    <Tab icon={<ReceiptIcon />} label="Tabelas de Convênios" iconPosition="start" />
                    <Tab icon={<MedicationIcon />} label="Base Brasíndice" iconPosition="start" />

                </Tabs>
            </Box>

            {tabValue === 0 && (
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <Paper sx={{ p: 3, borderRadius: 3 }}>
                            <Typography variant="h6" gutterBottom>Novo Convênio</Typography>
                            <TextField fullWidth label="Nome do Convênio" value={novoNome}
                                onChange={(e) => setNovoNome(e.target.value)} sx={{ mb: 2 }}
                                onKeyPress={(e) => e.key === 'Enter' && handleCreate()}
                            />
                            <StyledButton onClick={() => handleCreate(false)} fullWidth startIcon={<AddIcon />}>Adicionar</StyledButton>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={9}>
                        {/* Traffic Light RCM Panel */}
                        {dashboardLag && dashboardLag.fontes_defasadas > 0 && (
                            <Paper sx={{ mb: 3, p: 3, borderRadius: 3, bgcolor: '#fef2f2', border: '1px solid #fecaca' }}>
                                <Typography variant="h6" color="error.main" fontWeight={800} display="flex" alignItems="center" gutterBottom>
                                    <BrasindiceIcon sx={{ mr: 1 }} />
                                    🚨 Alerta RCM: Prejuízo Oculto Detectado
                                </Typography>
                                <Typography variant="body2" color="error.dark" mb={2}>
                                    O mercado está operando com o Brasíndice edição <b>{dashboardLag.max_versao}</b>, mas você possui <b>{dashboardLag.fontes_defasadas}</b> tabela(s) rodando versões defasadas. Atualize para não perder margem!
                                </Typography>
                                <Grid container spacing={2}>
                                    {dashboardLag.detalhes.map((det, idx) => (
                                        <Grid item xs={12} sm={6} md={4} key={idx}>
                                            <Card sx={{ bgcolor: 'white', border: '1px dashed #fca5a5' }} elevation={0}>
                                                <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                                    <Typography variant="caption" color="text.secondary" fontWeight={700} display="block">
                                                        {det.convenio_nome}
                                                    </Typography>
                                                    <Typography variant="body2" fontWeight={800} color="error.main">
                                                        {det.fonte_nome}
                                                    </Typography>
                                                    <Box display="flex" justifyContent="space-between" mt={1}>
                                                        <Chip size="small" label={`Atual: v${det.versao_atual}`} color="error" variant="outlined" />
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>
                        )}

                        {loading ? <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box> : convenios.map((c) => (
                            <Paper key={c.id} sx={{ mb: 2, borderRadius: 3, overflow: 'hidden', border: expandedConvenio === c.id ? '2px solid #6366f1' : '1px solid rgba(0,0,0,0.08)' }}>
                                {/* Convênio header row */}
                                <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', bgcolor: expandedConvenio === c.id ? 'rgba(99,102,241,0.05)' : 'transparent' }}
                                    onClick={() => handleToggleConvenio(c.id)}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <ReceiptIcon sx={{ color: '#6366f1' }} />
                                        <Typography fontWeight={700} fontSize="1.05rem">{c.nome}</Typography>
                                        {fontesPorConvenio[c.id] && (
                                            <Chip label={`${fontesPorConvenio[c.id].length} fonte(s)`} size="small" sx={{ bgcolor: '#EEF2FF', color: '#4F46E5', fontWeight: 700 }} />
                                        )}
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Tooltip title="Adicionar Fonte de Preço">
                                            <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); openNovaFonteDialog(c.id); }}>
                                                <AddIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Renomear Convênio">
                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); setEditingConvenio({ id: c.id, nome: c.nome }); setEditConvenioDialogOpen(true); }}>
                                                <EditIcon fontSize="small" color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <IconButton size="small" color="error" onClick={(e) => { e.stopPropagation(); handleDeleteConvenio(c.id, false); }}><DeleteIcon fontSize="small" /></IconButton>
                                        <ExpandMoreIcon sx={{ transition: '0.2s', transform: expandedConvenio === c.id ? 'rotate(180deg)' : 'none', color: 'text.secondary' }} />
                                    </Box>
                                </Box>

                                {/* Expanded fontes panel */}
                                {expandedConvenio === c.id && (
                                    <Box sx={{ borderTop: '1px solid rgba(0,0,0,0.08)', p: 2 }}>
                                        {!fontesPorConvenio[c.id] ? <CircularProgress size={24} /> : fontesPorConvenio[c.id].length === 0 ? (
                                            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
                                                <Typography variant="body2">Nenhuma fonte de preço configurada.</Typography>
                                                <Button size="small" startIcon={<AddIcon />} onClick={() => openNovaFonteDialog(c.id)} sx={{ mt: 1 }}>
                                                    Adicionar primeira fonte
                                                </Button>
                                            </Box>
                                        ) : (
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow sx={{ bgcolor: 'rgba(0,0,0,0.02)' }}>
                                                        <TableCell sx={{ fontWeight: 700, width: 60 }}>Prior.</TableCell>
                                                        <TableCell sx={{ fontWeight: 700 }}>Nome da Fonte</TableCell>
                                                        <TableCell sx={{ fontWeight: 700 }}>Categoria</TableCell>
                                                        <TableCell sx={{ fontWeight: 700 }}>Tipo</TableCell>
                                                        <TableCell sx={{ fontWeight: 700 }}>Config</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, width: 80 }}>Itens</TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: 700 }}>Ações</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {fontesPorConvenio[c.id].map((f, idx) => (
                                                        <TableRow key={f.id} hover sx={{ opacity: f.ativo ? 1 : 0.5 }}>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    <IconButton size="small" onClick={() => handleUpdatePrioridade(f.id, c.id, f.prioridade - 1)} disabled={f.prioridade <= 1}>
                                                                        <ArrowUpIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                    <Typography variant="caption" fontWeight={700}>{f.prioridade}</Typography>
                                                                    <IconButton size="small" onClick={() => handleUpdatePrioridade(f.id, c.id, f.prioridade + 1)}>
                                                                        <ArrowDownIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>{f.nome}</TableCell>
                                                            <TableCell>
                                                                <Chip label={f.categoria} size="small" variant="outlined" />
                                                            </TableCell>
                                                            <TableCell>
                                                                {f.fonte === 'BRASINDICE' ? (
                                                                    <Chip label="🧬 Brasíndice" size="small" sx={{ bgcolor: '#ECFDF5', color: '#059669', fontWeight: 700 }} />
                                                                ) : (
                                                                    <Chip label="📄 Importada" size="small" sx={{ bgcolor: '#EFF6FF', color: '#2563EB', fontWeight: 700 }} />
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {f.fonte === 'BRASINDICE' ? (
                                                                    <Typography variant="caption" color="success.main" fontWeight={700}>
                                                                        {f.base_referencia} {f.percentual_ajuste >= 0 ? '+' : ''}{f.percentual_ajuste}%
                                                                        {f.versao_brasindice && ` (ed.${f.versao_brasindice})`}
                                                                    </Typography>
                                                                ) : (
                                                                    <Box>
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            {f.num_itens != null ? `${f.num_itens} itens` : '—'}
                                                                        </Typography>
                                                                        {(f.vigencia_inicio || f.vigencia_fim) && (
                                                                            <Typography variant="caption" display="block" color="primary" fontWeight={600}>
                                                                                📅 {f.vigencia_inicio ? new Date(f.vigencia_inicio + 'T00:00:00').toLocaleDateString('pt-BR') : '∞'}
                                                                                {' → '}
                                                                                {f.vigencia_fim ? new Date(f.vigencia_fim + 'T00:00:00').toLocaleDateString('pt-BR') : 'sem prazo'}
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {f.fonte === 'IMPORTADA' && (
                                                                    <Chip label={f.num_itens ?? 0} size="small" color={f.num_itens > 0 ? 'primary' : 'default'} />
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                                                                    <Tooltip title="Ver itens importados">
                                                                        <IconButton size="small" color="info" onClick={() => handleVerItens(f)}>
                                                                            <VisibilityIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    {(['IMPORTADA', 'IPE-MEDICAMENTOS', 'IPE-DESPESAS', 'IPE-INSUMOS'].includes(f.fonte)) && (
                                                                        <Tooltip title="Importar arquivo para esta fonte">
                                                                            <IconButton component="label" size="small" color="primary">
                                                                                <UploadIcon fontSize="small" />
                                                                                <input type="file" hidden accept=".xlsx,.xls,.csv,.txt"
                                                                                    onChange={(e) => handleImportToFonte(f.id, c.id, e.target.files[0])} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    )}
                                                                    <Tooltip title="Editar fonte">
                                                                        <IconButton size="small" color="primary" onClick={() => handleOpenEditFonte(f)}>
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Excluir fonte">
                                                                        <IconButton size="small" color="error" onClick={() => handleDeleteFonte(f.id, c.id)}>
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        )}
                                    </Box>
                                )}
                            </Paper>
                        ))}
                    </Grid>
                </Grid>
            )}

            {tabValue === 1 && (
                <Paper sx={{ p: 3, borderRadius: 3 }}>
                    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                            <Typography variant="h6" fontWeight={700}>Catálogo Brasíndice</Typography>
                            <TextField
                                size="small"
                                placeholder="Buscar Medicamento/EAN..."
                                value={searchBrasindice}
                                onChange={(e) => setSearchBrasindice(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && fetchBrasindice()}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={fetchBrasindice}><SearchIcon /></IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <FormControl size="small" sx={{ minWidth: 130 }}>
                                <InputLabel>Tipo</InputLabel>
                                <Select
                                    label="Tipo"
                                    value={importTypeSelector}
                                    onChange={(e) => setImportTypeSelector(e.target.value)}
                                >
                                    <MenuItem value="MEDICAMENTO">Medicamento</MenuItem>
                                    <MenuItem value="MATERIAL">Material</MenuItem>
                                    <MenuItem value="SOLUCAO">Solução</MenuItem>
                                    <MenuItem value="ONCOLOGIA">Oncologia</MenuItem>
                                </Select>
                            </FormControl>
                            <IconButton color="secondary" onClick={() => {
                                setCurrentImportType('BRASINDICE');
                                fetchBrasindiceVersions();
                                setVersionDialogOpen(true);
                            }}>
                                <Tooltip title="Gerenciar Importações"><VisibilityIcon /></Tooltip>
                            </IconButton>
                            <TextField size="small" placeholder="Versão" sx={{ width: 100 }}
                                value={importInfo.versao} onChange={(e) => setImportInfo({ ...importInfo, versao: e.target.value })}
                            />
                            <TextField size="small" placeholder="Vigência" sx={{ width: 100 }}
                                value={importInfo.vigencia} onChange={(e) => setImportInfo({ ...importInfo, vigencia: e.target.value })}
                            />
                            <Button
                                component="label"
                                variant="contained"
                                startIcon={importing ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />}
                                disabled={importing}
                            >
                                Importar
                                <input type="file" hidden accept=".xlsx,.xls,.csv,.txt" onChange={(e) => handleImportBrasindice(e.target.files[0])} />
                            </Button>
                        </Box>
                    </Box>

                    {importing && (
                        <Box sx={{ mb: 3 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2" color="textSecondary">Processando arquivo...</Typography>
                                <Typography variant="body2" fontWeight="bold">{importProgress}%</Typography>
                            </Box>
                            <LinearProgress variant="determinate" value={importProgress} sx={{ height: 10, borderRadius: 5 }} />
                        </Box>
                    )}

                    <TableContainer sx={{ maxHeight: 600 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Tipo</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Versão/Vig.</TableCell>
                                    <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={() => handleRequestSort('laboratorio')}>Laboratório</TableCell>
                                    <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={() => handleRequestSort('nome_comercial')}>Produto</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Apresentação</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>EAN</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>TISS</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>TUSS</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Preços (PF/PMC)</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700 }}>Qtd/P.Frac</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 700 }}>Extras</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>Códigos</TableCell>
                                </TableRow>
                                <TableRow sx={{ bgcolor: 'rgba(0,0,0,0.02)' }}>
                                    <TableCell sx={{ p: 0.5 }}>
                                        <TextField size="small" value={filters.tipo} onChange={(e) => handleFilterChange('tipo', e.target.value)} sx={{ scale: '0.8' }} placeholder="Filtro" />
                                    </TableCell>
                                    <TableCell />
                                    <TableCell sx={{ p: 0.5 }}>
                                        <TextField size="small" value={filters.laboratorio} onChange={(e) => handleFilterChange('laboratorio', e.target.value)} sx={{ scale: '0.8' }} placeholder="Filtro" />
                                    </TableCell>
                                    <TableCell sx={{ p: 0.5 }}>
                                        <TextField size="small" value={filters.nome_comercial} onChange={(e) => handleFilterChange('nome_comercial', e.target.value)} sx={{ scale: '0.8' }} placeholder="Filtro" />
                                    </TableCell>
                                    <TableCell sx={{ p: 0.5 }}>
                                        <TextField size="small" value={filters.apresentacao} onChange={(e) => handleFilterChange('apresentacao', e.target.value)} sx={{ scale: '0.8' }} placeholder="Filtro" />
                                    </TableCell>
                                    <TableCell sx={{ p: 0.5 }}>
                                        <TextField size="small" value={filters.ean} onChange={(e) => handleFilterChange('ean', e.target.value)} sx={{ scale: '0.8' }} placeholder="Filtro" />
                                    </TableCell>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell colSpan={4} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadingBrasindice ? (
                                    <TableRow><TableCell colSpan={6} align="center"><CircularProgress sx={{ m: 2 }} /></TableCell></TableRow>
                                ) : (
                                    filteredBrasindice.slice(brasindicePage * brasindiceRowsPerPage, brasindicePage * brasindiceRowsPerPage + brasindiceRowsPerPage).map((item) => (
                                        <TableRow key={item.id} hover>
                                            <TableCell><Typography variant="caption" sx={{ fontWeight: 800, color: '#6366f1' }}>{item.tipo}</Typography></TableCell>
                                            <TableCell>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{item.versao || '-'}</Typography>
                                                <Typography variant="caption" color="textSecondary">{item.vigencia ? new Date(item.vigencia).toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' }) : '-'}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                <Typography variant="caption" color="primary">{item.c_lab}</Typography>
                                                <Tooltip title={item.laboratorio}><Box sx={{ fontSize: '0.85rem' }}>{item.laboratorio}</Box></Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="caption" color="secondary">{item.c_prod}</Typography>
                                                <Box sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>{item.nome_comercial}</Box>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="caption">{item.c_apres}</Typography>
                                                <Box sx={{ fontSize: '0.8rem' }}>{item.apresentacao}</Box>
                                            </TableCell>
                                            <TableCell><Typography variant="caption">{item.ean}</Typography></TableCell>
                                            <TableCell><Typography variant="caption">{item.tiss}</Typography></TableCell>
                                            <TableCell><Typography variant="caption">{item.tuss}</Typography></TableCell>
                                            <TableCell align="right">
                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Typography variant="body2" color="primary">PF: {item.pf?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</Typography>
                                                    <Typography variant="body2" color="secondary">PMC: {item.pmc?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="body2">Q: {item.qtd_frac}</Typography>
                                                <Typography variant="caption" color="textSecondary">P.Fr: {item.preco_frac?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</Typography>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                                                    <Tooltip title={`Edição: ${item.edicao}`}><span><Typography variant="caption">Ed:{item.edicao}</Typography></span></Tooltip>
                                                    <Tooltip title={`IPI: ${item.ipi}%`}><span><Typography variant="caption">IPI:{item.ipi}</Typography></span></Tooltip>
                                                    <Tooltip title={`Portaria: ${item.portaria}`}><span><Typography variant="caption">P:{item.portaria}</Typography></span></Tooltip>
                                                    {item.generico === 'S' && <Chip label="G" size="small" color="success" sx={{ height: 16, fontSize: '0.6rem' }} />}
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>GG:{item.ggrem}</Typography>
                                                    <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>ANV:{item.anvisa}</Typography>
                                                    <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>HIE:{item.hierarquia}</Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                                {!loadingBrasindice && brasindice.length === 0 && (
                                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4 }}>Nenhum item encontrado.</TableCell></TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        count={filteredBrasindice.length}
                        page={brasindicePage}
                        onPageChange={(e, p) => setBrasindicePage(p)}
                        rowsPerPage={brasindiceRowsPerPage}
                        onRowsPerPageChange={(e) => { setBrasindiceRowsPerPage(parseInt(e.target.value, 10)); setBrasindicePage(0); }}
                        labelRowsPerPage="Itens por página"
                    />
                </Paper>
            )}

            {tabValue === 2 && (
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <Paper sx={{ p: 3, borderRadius: 3 }}>
                            <Typography variant="h6" fontWeight={700} gutterBottom>Novo Convênio Custom</Typography>
                            <TextField fullWidth label="Nome do Convênio" size="small" value={novoNome}
                                onChange={(e) => setNovoNome(e.target.value)} sx={{ mb: 2 }}
                                onKeyPress={(e) => e.key === 'Enter' && handleCreate(true)}
                            />
                            <StyledButton onClick={() => handleCreate(true)} fullWidth startIcon={<AddIcon />}>Adicionar</StyledButton>

                            <Divider sx={{ my: 3 }} />

                            <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2, fontWeight: 700 }}>REFERÊNCIAS GLOBAIS IPE</Typography>
                            <Tabs orientation="vertical" value={subTabIpe} onChange={(e, v) => setSubTabIpe(v)} sx={{ borderRight: 1, borderColor: 'divider' }}>
                                <Tab label="Insumos IPE" />
                                <Tab label="Despesas IPE" />
                            </Tabs>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={9}>
                        {/* IPE Global Reference View */}
                        <Paper sx={{ p: 3, borderRadius: 3, mb: 3 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" fontWeight={700}>
                                    {subTabIpe === 0 ? 'Referência de Insumos IPE' : 'Referência de Despesas Hospitalares IPE'}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <TextField size="small" placeholder="Buscar..." value={searchIpe}
                                        onChange={(e) => setSearchIpe(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && fetchIpeData()}
                                    />
                                    <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
                                        Importar
                                        <input type="file" hidden onChange={(e) => subTabIpe === 0 ? handleImportIpeInsumos(e.target.files[0]) : handleImportIpeDespesas(e.target.files[0])} />
                                    </Button>
                                </Box>
                            </Box>

                            <TableContainer sx={{ maxHeight: 400 }}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>Código</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Descrição</TableCell>
                                            {subTabIpe === 1 && <TableCell sx={{ fontWeight: 700 }}>Cat/Tipo</TableCell>}
                                            <TableCell sx={{ fontWeight: 700 }} align="right">Valor (R$)</TableCell>
                                            {subTabIpe === 1 && <TableCell sx={{ fontWeight: 700 }} align="right">Privativo</TableCell>}
                                            {subTabIpe === 1 && <TableCell sx={{ fontWeight: 700 }} align="right">PAMES</TableCell>}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loadingIpe ? (
                                            <TableRow><TableCell colSpan={6} align="center"><CircularProgress sx={{ m: 2 }} /></TableCell></TableRow>
                                        ) : (subTabIpe === 0 ? ipeInsumos : ipeDespesas).map((i) => (
                                            <TableRow key={i.id} hover>
                                                <TableCell sx={{ fontWeight: 700 }}>{i.codigo}</TableCell>
                                                <TableCell>{i.descricao}</TableCell>
                                                {subTabIpe === 1 && <TableCell>{i.categoria} / {i.tipo_despesa}</TableCell>}
                                                <TableCell align="right">{i.valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                                                {subTabIpe === 1 && <TableCell align="right">{i.valor_privativo?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>}
                                                {subTabIpe === 1 && <TableCell align="right">{i.valor_pames?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                component="div"
                                count={ipeTotal}
                                page={ipePage}
                                onPageChange={(e, p) => setIpePage(p)}
                                rowsPerPage={ipeRowsPerPage}
                                onRowsPerPageChange={(e) => setIpeRowsPerPage(parseInt(e.target.value, 10))}
                            />
                        </Paper>

                        {/* Custom Convenios List */}
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>Convênios Personalizados</Typography>
                        {loading ? <CircularProgress /> : customConvenios.map((c) => (
                            <Paper key={c.id} sx={{ mb: 2, borderRadius: 3, overflow: 'hidden', border: expandedConvenio === c.id ? '2px solid #6366f1' : '1px solid rgba(0,0,0,0.08)' }}>
                                <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', bgcolor: expandedConvenio === c.id ? 'rgba(99,102,241,0.05)' : 'transparent' }}
                                    onClick={() => handleToggleConvenio(c.id)}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <ReceiptIcon sx={{ color: '#6366f1' }} />
                                        <Typography fontWeight={700} fontSize="1.05rem">{c.nome}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Tooltip title="Renomear Convênio">
                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); setEditingConvenio({ id: c.id, nome: c.nome }); setEditConvenioDialogOpen(true); }}>
                                                <EditIcon fontSize="small" color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Adicionar Fonte de Preço"><IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); openNovaFonteDialog(c.id); }}><AddIcon /></IconButton></Tooltip>
                                        <IconButton size="small" color="error" onClick={(e) => { e.stopPropagation(); handleDeleteConvenio(c.id, true); }}><DeleteIcon /></IconButton>
                                        {expandedConvenio === c.id ? <ArrowUpIcon /> : <ArrowDownIcon />}
                                    </Box>
                                </Box>

                                {expandedConvenio === c.id && (
                                    <Box sx={{ p: 2, bgcolor: '#fbfbff' }}>
                                        <Grid container spacing={2}>
                                            {(fontesPorConvenio[c.id] || []).map(f => (
                                                <Grid item xs={12} key={f.id}>
                                                    <Card variant="outlined" sx={{ borderRadius: 2 }}>
                                                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <Box>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <Typography variant="subtitle1" fontWeight={700}>{f.nome}</Typography>
                                                                    <Chip label={f.fonte} size="small" color="primary" variant="outlined" />
                                                                </Box>
                                                                <Typography variant="caption" color="textSecondary">{f.categoria} | Prioridade: {f.prioridade}</Typography>
                                                            </Box>
                                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                                <Tooltip title="Visualizar Itens"><IconButton size="small" onClick={() => handleVerItens(f)}><VisibilityIcon /></IconButton></Tooltip>
                                                                <Tooltip title="Importar Arquivo">
                                                                    <IconButton component="label" size="small" color="primary">
                                                                        <UploadIcon />
                                                                        <input type="file" hidden onChange={(e) => {
                                                                            if (f.fonte === 'IPE-DESPESAS') handleImportIpeDespesas(e.target.files[0], f.id);
                                                                            else if (f.fonte === 'IPE-INSUMOS') handleImportIpeInsumos(e.target.files[0], f.id);
                                                                            else if (f.fonte === 'IPE-MEDICAMENTOS') handleImportIpeMeds(e.target.files[0]);
                                                                            else handleImportToFonte(f.id, c.id, e.target.files[0]);
                                                                        }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <IconButton size="small" color="primary" onClick={() => handleOpenEditFonte(f)}><EditIcon /></IconButton>
                                                                <IconButton size="small" color="error" onClick={() => handleDeleteFonte(f.id, c.id)}><DeleteIcon /></IconButton>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                )}
                            </Paper>
                        ))}
                    </Grid>
                </Grid>
            )}

            {/* Nova Fonte de Preço Dialog */}
            <Dialog open={novaFonteDialogOpen} onClose={() => setNovaFonteDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold' }}>
                    Nova Fonte de Preço
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        <Grid item xs={12} sm={8}>
                            <TextField fullWidth label="Nome da Fonte" size="small"
                                placeholder='Ex: "Tabela TISS 2026", "Brasíndice PF"'
                                value={novaFonte.nome}
                                onChange={(e) => setNovaFonte({ ...novaFonte, nome: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth label="Filtro Carteira (Inicia com)" size="small"
                                placeholder='Ex: "00410"'
                                value={novaFonte.filtro_carteira}
                                onChange={(e) => setNovaFonte({ ...novaFonte, filtro_carteira: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Categoria</InputLabel>
                                <Select label="Categoria" value={novaFonte.categoria}
                                    onChange={(e) => setNovaFonte({ ...novaFonte, categoria: e.target.value })}>
                                    <MenuItem value="PROCEDIMENTO">Procedimento</MenuItem>
                                    <MenuItem value="TAXA">Taxa / Diária</MenuItem>
                                    <MenuItem value="MATERIAL">Material</MenuItem>
                                    <MenuItem value="MEDICAMENTO">Medicamento</MenuItem>
                                    <MenuItem value="TODOS">Todos</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Tipo de Fonte</InputLabel>
                                <Select label="Tipo de Fonte" value={novaFonte.fonte}
                                    onChange={(e) => setNovaFonte({ ...novaFonte, fonte: e.target.value })}>
                                    <MenuItem value="IMPORTADA">📄 Tabela Importada (CSV/XLSX)</MenuItem>
                                    <MenuItem value="BRASINDICE">🧬 Brasíndice (automático)</MenuItem>
                                    <MenuItem value="IPE-MEDICAMENTOS">🏛️ IPE-Medicamentos (Referência RS)</MenuItem>
                                    <MenuItem value="IPE-DESPESAS">🏨 IPE-Despesas (Posicional)</MenuItem>
                                    <MenuItem value="IPE-INSUMOS">📦 IPE-Insumos (Referência RS)</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField fullWidth label="Prioridade" type="number" size="small"
                                value={novaFonte.prioridade}
                                onChange={(e) => setNovaFonte({ ...novaFonte, prioridade: parseInt(e.target.value) || 1 })}
                                inputProps={{ min: 1 }}
                            />
                        </Grid>

                        {novaFonte.fonte === 'BRASINDICE' && (<>
                            <Grid item xs={12}>
                                <Divider><Typography variant="caption" color="text.secondary">Configuração Brasíndice</Typography></Divider>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Base de Cálculo</InputLabel>
                                    <Select label="Base de Cálculo" value={novaFonte.base_referencia}
                                        onChange={(e) => setNovaFonte({ ...novaFonte, base_referencia: e.target.value })}>
                                        <MenuItem value="PF">PFB — Preço de Fábrica</MenuItem>
                                        <MenuItem value="PMC">PMC — Preço Máx. Consumidor</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Ajuste %" type="number" size="small"
                                    value={novaFonte.percentual_ajuste}
                                    onChange={(e) => setNovaFonte({ ...novaFonte, percentual_ajuste: parseFloat(e.target.value) || 0 })}
                                    InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Edição Brasíndice</InputLabel>
                                    <Select label="Edição Brasíndice" value={novaFonte.versao_brasindice}
                                        onChange={(e) => setNovaFonte({ ...novaFonte, versao_brasindice: e.target.value })}>
                                        <MenuItem value=""><em>Mais recente</em></MenuItem>
                                        {brasindiceVersoesParaRegra.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(5,150,105,0.08)', borderRadius: 2 }}>
                                    <Typography variant="caption" color="success.main" fontWeight={700}>
                                        📊 Fórmula: Preço = Brasíndice {novaFonte.base_referencia || 'PF'}
                                        {novaFonte.versao_brasindice ? ` (ed.${novaFonte.versao_brasindice})` : ' (mais recente)'}
                                        {' '}{novaFonte.percentual_ajuste >= 0 ? '+' : ''}{novaFonte.percentual_ajuste}%
                                    </Typography>
                                </Box>
                            </Grid>
                        </>)}

                        {novaFonte.fonte === 'IMPORTADA' && (<>
                            <Grid item xs={12}>
                                <Divider><Typography variant="caption" color="text.secondary">Vigência da Tabela (opcional)</Typography></Divider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth size="small" label="Início da Vigência"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={novaFonte.vigencia_inicio}
                                    onChange={(e) => setNovaFonte({ ...novaFonte, vigencia_inicio: e.target.value })}
                                    helperText="Data a partir da qual os preços valem"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth size="small" label="Fim da Vigência"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={novaFonte.vigencia_fim}
                                    onChange={(e) => setNovaFonte({ ...novaFonte, vigencia_fim: e.target.value })}
                                    helperText="Deixe em branco = sem prazo de vencimento"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(37,99,235,0.05)', borderRadius: 2, border: '1px dashed #93C5FD' }}>
                                    <Typography variant="caption" color="primary">
                                        💡 Após criar a fonte, use o botão <strong>📤</strong> para carregar o arquivo CSV/XLSX. Os preços serão associados à vigência informada acima e a auditoria só usará esta tabela para itens com data dentro do período.
                                    </Typography>
                                </Box>
                            </Grid>
                        </>)}

                        {(novaFonte.fonte === 'IPE-MEDICAMENTOS') && (
                            <Grid item xs={12}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(37,99,235,0.05)', borderRadius: 2, border: '1px dashed #93C5FD' }}>
                                    <Typography variant="caption" color="primary">
                                        💡 Após criar a fonte, use o botão <strong>📤</strong> para carregar o arquivo CSV/XLSX com os itens e preços.
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setNovaFonteDialogOpen(false)}>Cancelar</Button>
                    <Button onClick={handleCreateFonte} variant="contained" disabled={!novaFonte.nome}>
                        Criar Fonte
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Editar Fonte de Preço Dialog */}
            <Dialog open={editFonteDialogOpen} onClose={() => setEditFonteDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold' }}>Editar Fonte: {editingFonte?.nome}</DialogTitle>
                <DialogContent dividers>
                    {editingFonte && (
                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item xs={12} sm={8}>
                                <TextField fullWidth label="Nome da Fonte" size="small"
                                    value={editingFonte.nome}
                                    onChange={(e) => setEditingFonte({ ...editingFonte, nome: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Filtro Carteira (Inicia com)" size="small"
                                    value={editingFonte.filtro_carteira}
                                    onChange={(e) => setEditingFonte({ ...editingFonte, filtro_carteira: e.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Categoria</InputLabel>
                                    <Select label="Categoria" value={editingFonte.categoria}
                                        onChange={(e) => setEditingFonte({ ...editingFonte, categoria: e.target.value })}>
                                        <MenuItem value="PROCEDIMENTO">Procedimento</MenuItem>
                                        <MenuItem value="TAXA">Taxa / Diária</MenuItem>
                                        <MenuItem value="MATERIAL">Material</MenuItem>
                                        <MenuItem value="MEDICAMENTO">Medicamento</MenuItem>
                                        <MenuItem value="TODOS">Todos</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField fullWidth label="Prioridade" type="number" size="small"
                                    value={editingFonte.prioridade}
                                    onChange={(e) => setEditingFonte({ ...editingFonte, prioridade: parseInt(e.target.value) || 1 })}
                                />
                            </Grid>

                            {editingFonte.fonte === 'BRASINDICE' && (<>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Base</InputLabel>
                                        <Select label="Base" value={editingFonte.base_referencia}
                                            onChange={(e) => setEditingFonte({ ...editingFonte, base_referencia: e.target.value })}>
                                            <MenuItem value="PF">PFB — Preço de Fábrica</MenuItem>
                                            <MenuItem value="PMC">PMC — Preço Máx. Consumidor</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField fullWidth label="Ajuste %" type="number" size="small"
                                        value={editingFonte.percentual_ajuste}
                                        onChange={(e) => setEditingFonte({ ...editingFonte, percentual_ajuste: parseFloat(e.target.value) || 0 })}
                                    />
                                </Grid>
                            </>)}

                            {(editingFonte.fonte === 'IMPORTADA' || editingFonte.fonte === 'IPE-DESPESAS') && (<>
                                <Grid item xs={12} sm={6}>
                                    <TextField fullWidth size="small" label="Início da Vigência" type="date" InputLabelProps={{ shrink: true }}
                                        value={editingFonte.vigencia_inicio}
                                        onChange={(e) => setEditingFonte({ ...editingFonte, vigencia_inicio: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField fullWidth size="small" label="Fim da Vigência" type="date" InputLabelProps={{ shrink: true }}
                                        value={editingFonte.vigencia_fim}
                                        onChange={(e) => setEditingFonte({ ...editingFonte, vigencia_fim: e.target.value })}
                                    />
                                </Grid>
                            </>)}
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditFonteDialogOpen(false)}>Cancelar</Button>
                    <Button onClick={handleUpdateFonte} variant="contained">Salvar Alterações</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={versionDialogOpen} onClose={() => setVersionDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold' }}>
                    Importações Realizadas: {currentImportType === 'TISS' ? selectedConvenioVersions?.nome : 'Brasíndice'}
                </DialogTitle>
                <DialogContent dividers>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Versão</TableCell>
                                {currentImportType === 'TISS' && <TableCell>Vigência</TableCell>}
                                <TableCell align="right">Registros</TableCell>
                                <TableCell align="right">Ação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(currentImportType === 'TISS' ? versoesTabela : brasindiceVersoes).length === 0 && (
                                <TableRow><TableCell colSpan={4} align="center">Nenhuma importação encontrada.</TableCell></TableRow>
                            )}
                            {(currentImportType === 'TISS' ? versoesTabela : brasindiceVersoes).map((v) => (
                                <TableRow key={v.id}>
                                    <TableCell sx={{ fontWeight: 'bold' }}>{v.versao}</TableCell>
                                    {currentImportType === 'TISS' && <TableCell>{v.vigencia}</TableCell>}
                                    <TableCell align="right">{v.itens}</TableCell>
                                    <TableCell align="right">
                                        <IconButton size="small" color="error" onClick={() => {
                                            if (currentImportType === 'TISS') handleDeleteTissVersion(v.versao, v.vigencia);
                                            else handleDeleteBrasindiceVersion(v.versao);
                                        }}><DeleteIcon /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setVersionDialogOpen(false)} sx={{ fontWeight: 'bold' }}>Fechar</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog para Renomear Convênio */}
            <Dialog open={editConvenioDialogOpen} onClose={() => setEditConvenioDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold' }}>Renomear Convênio</DialogTitle>
                <DialogContent>
                    <Box sx={{ pt: 1 }}>
                        <TextField
                            fullWidth label="Novo Nome" size="small" autoFocus
                            value={editingConvenio.nome}
                            onChange={(e) => setEditingConvenio({ ...editingConvenio, nome: e.target.value })}
                            onKeyPress={(e) => e.key === 'Enter' && handleUpdateConvenio()}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditConvenioDialogOpen(false)}>Cancelar</Button>
                    <Button onClick={handleUpdateConvenio} variant="contained" disabled={!editingConvenio.nome}>Salvar</Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert severity={snackbar.severity} sx={{ borderRadius: 2 }}>{snackbar.message}</Alert>
            </Snackbar>
            {/* Modal de Visualização de Itens da Fonte */}
            <Dialog open={itensFonteDialogOpen} onClose={() => setItensFonteDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TableChartIcon color="primary" />
                        Itens da Fonte: {selectedFonte?.nome}
                    </Box>
                    <IconButton onClick={() => setItensFonteDialogOpen(false)}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Buscar por código ou descrição..."
                            value={searchItens}
                            onChange={(e) => setSearchItens(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && fetchItensDaFonte(selectedFonte.id, 1, searchItens)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => fetchItensDaFonte(selectedFonte.id, 1, searchItens)}><SearchIcon /></IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>

                    <TableContainer sx={{ maxHeight: 400 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa' }}>Código</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa' }}>Descrição</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa' }} align="right">Valor (R$)</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa' }}>Vigência Ref.</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8f9fa', width: 100 }} align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadingItens ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ py: 4 }}><CircularProgress size={30} /></TableCell>
                                    </TableRow>
                                ) : itensDaFonte.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ py: 4 }}>Nenhum item encontrado.</TableCell>
                                    </TableRow>
                                ) : itensDaFonte.map((item) => (
                                    <TableRow key={item.id} hover>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                            {editingItemId === item.id ? (
                                                <TextField size="small" value={editValues.codigo}
                                                    onChange={(e) => setEditValues({ ...editValues, codigo: e.target.value })} />
                                            ) : (
                                                item.codigo
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {editingItemId === item.id ? (
                                                <TextField fullWidth size="small" value={editValues.descricao}
                                                    onChange={(e) => setEditValues({ ...editValues, descricao: e.target.value })} />
                                            ) : (
                                                item.descricao
                                            )}
                                        </TableCell>
                                        <TableCell align="right">
                                            {editingItemId === item.id ? (
                                                <TextField size="small" value={editValues.valor}
                                                    onChange={(e) => setEditValues({ ...editValues, valor: e.target.value })}
                                                    sx={{ width: 100 }} />
                                            ) : (
                                                item.valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                                            )}
                                        </TableCell>
                                        <TableCell>{item.vigencia_referencia || '—'}</TableCell>
                                        <TableCell align="center">
                                            {editingItemId === item.id ? (
                                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                                    <IconButton size="small" color="success" onClick={handleSaveEdit}>
                                                        <SaveIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton size="small" color="error" onClick={() => setEditingItemId(null)}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            ) : (
                                                <IconButton size="small" color="primary" onClick={() => handleStartEdit(item)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        component="div"
                        count={itensTotal}
                        page={itensPage - 1} // MUI uses 0-based index
                        onPageChange={(e, newPage) => fetchItensDaFonte(selectedFonte.id, newPage + 1, searchItens)}
                        rowsPerPage={itensRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50]}
                        onRowsPerPageChange={(e) => {
                            setItensRowsPerPage(parseInt(e.target.value, 10));
                            setItensPage(1);
                            fetchItensDaFonte(selectedFonte.id, 1, searchItens);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setItensFonteDialogOpen(false)} color="primary">Fechar</Button>
                </DialogActions>
            </Dialog>

            {/* Modal de Confirmação de Exclusão de Convênio */}
            <Dialog open={deleteConfirmation.open} onClose={() => setDeleteConfirmation({ ...deleteConfirmation, open: false })} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, color: 'error.main' }}>
                    ⚠️ Confirmação de Exclusão em Cascata
                </DialogTitle>
                <DialogContent dividers>
                    {deleteConfirmation.data && (
                        <Box>
                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                                {deleteConfirmation.data.message}
                            </Typography>

                            <Paper variant="outlined" sx={{ bgcolor: 'error.50', borderColor: 'error.200', p: 2, borderRadius: 2 }}>
                                <Typography variant="subtitle2" color="error.main" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                                    Os seguintes registros serão PERDIDOS e não poderão ser recuperados:
                                </Typography>
                                <ul style={{ margin: 0, paddingLeft: '20px', color: '#d32f2f' }}>
                                    {Object.entries(deleteConfirmation.data.dependencies).map(([key, count]) => (
                                        <li key={key} style={{ marginBottom: '8px' }}>
                                            <strong>{count}</strong> {key}
                                        </li>
                                    ))}
                                </ul>
                            </Paper>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2, bgcolor: '#f8f9fa' }}>
                    <Button onClick={() => setDeleteConfirmation({ ...deleteConfirmation, open: false })} variant="outlined" sx={{ fontWeight: 'bold' }}>
                        Cancelar
                    </Button>
                    <Button onClick={confirmDeleteConvenio} variant="contained" color="error" sx={{ fontWeight: 'bold' }}>
                        Confirmar Exclusão Definitiva
                    </Button>
                </DialogActions>
            </Dialog>
        </Container >
    );
};

export default CadastrosFaturamento;
